import { Typography } from '@mui/material';
import React, { ComponentPropsWithoutRef } from 'react';

interface FieldLabelProps extends ComponentPropsWithoutRef<'div'> {
  required?: boolean;
  disabled?: boolean;
}

export function CustomFieldLabel({ children, required, disabled }: FieldLabelProps) {
  return (
    <Typography
      variant="body1"
      sx={{
        color: disabled ? "var(--muted)" : "var(--Base-900, #444)",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: 450,
        lineHeight: "132%",
        marginBottom: 1,
      }}
    >
      {children}
      {required && (
        <Typography
          component="span"
          color={disabled ? "var(--muted)" : "error"}
          sx={{
            fontSize: "110%",
            fontWeight: 450,
          }}
        >
          *
        </Typography>
      )}
    </Typography>
  );
}

CustomFieldLabel.defaultProps = {
  required: false,
  disabled: false,
};
